/** PalletFlowBlockSlot — actuals + pallet accounts + docket number. */
import { Input } from "@/components/ui/input";
import { Field } from "../_shared";
import { useSlotLabel } from "../hooks/useSlotLabels";

export default function PalletFlowBlockSlot({ values, set }) {
  const lbl = useSlotLabel("qa.pallet-flow");
  return (
    <div className="rounded-md border bg-amber-50/50 p-3 space-y-2">
      <div className="flex items-center justify-between">
        <div className="text-xs uppercase tracking-wider text-amber-700 font-medium">
          {lbl("section_title", "Pallet flow (actuals + account)")}
        </div>
        <span className="text-[11px] text-amber-700/60">
          Variance vs expected auto-raises a &quot;pallets&quot; NCR
        </span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <Field label={`${lbl("actual_in", "Actual pallets IN")}${values.pallets_in !== "" ? ` (expected ${values.pallets_in})` : ""}`}>
          <Input type="number" min="0" value={values.actual_pallets_in}
                 onChange={(e) => set("actual_pallets_in", e.target.value)}
                 data-testid="booking-actual-pallets-in" />
        </Field>
        <Field label={`${lbl("actual_out", "Actual pallets OUT")}${values.pallets_out !== "" ? ` (expected ${values.pallets_out})` : ""}`}>
          <Input type="number" min="0" value={values.actual_pallets_out}
                 onChange={(e) => set("actual_pallets_out", e.target.value)}
                 data-testid="booking-actual-pallets-out" />
        </Field>
        <Field label={lbl("account_in", "Pallet account IN (sender brand acc.)")}>
          <Input data-testid="booking-pallet-account-in" value={values.pallet_account_in}
                 onChange={(e) => set("pallet_account_in", e.target.value)}
                 placeholder="e.g. CHEP-A12345" />
        </Field>
        <Field label={lbl("account_out", "Pallet account OUT (receiver brand acc.)")}>
          <Input data-testid="booking-pallet-account-out" value={values.pallet_account_out}
                 onChange={(e) => set("pallet_account_out", e.target.value)}
                 placeholder="e.g. LOSCAM-B98765" />
        </Field>
        <Field label={lbl("docket", "Docket / transfer number")}>
          <Input data-testid="booking-pallet-docket-number" value={values.pallet_docket_number}
                 onChange={(e) => set("pallet_docket_number", e.target.value)}
                 placeholder="e.g. CHEP TRF-#019283" />
        </Field>
      </div>
    </div>
  );
}
